module.exports = __webpack_public_path__ + "img/hr-curved-rail-vertical-left-top-segment-visualisation-middle.45f25d1f.png";